import { useAuthContext } from '@/modules/Auth/contexts/AuthContext'
import { RealtimeAttendanceMonitoringService } from '@/modules/RealtimeAttendanceMonitoring/services'
import { useCallback } from 'react'

type GetCurrentAppointmentImmediate = {
  mode: 'immediate'
  queueId: string
}

type GetCurrentAppointmentScheduled = {
  mode: 'scheduled'
  appointmentId: number
}

type GetCurrentAppointmentParams =
  | GetCurrentAppointmentImmediate
  | GetCurrentAppointmentScheduled

export const useCurrentAppointment = () => {
  const { user } = useAuthContext()

  const getCurrentAppointment = useCallback(
    async (params: GetCurrentAppointmentParams) => {
      const appointments =
        await RealtimeAttendanceMonitoringService.getAppointmentStatus(
          user?.patientId,
        )

      if (params?.mode === 'immediate') {
        const currentAppointment = appointments?.find(
          appointment => appointment?.idFila === params?.queueId,
        )

        return currentAppointment
      }

      const currentAppointment = appointments?.find(
        appointment => appointment?.idAtendimento === params?.appointmentId,
      )

      return currentAppointment
    },
    [user?.patientId],
  )

  return {
    getCurrentAppointment,
  }
}
